
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import xhr from '../../utils/xhr';
import api from '../../api/Common.api';
import utils from '../../utils/utilities';
import DeliveryIcons from './../../reusable/DeliveryIcons/DeliveryIcons.jsx';
import withSpinner from '../Wrappers/SpinnerWrapper/SpinnerWrapper';
import PreviewArticle from '../PreviewArticle/PreviewArticle.index.jsx';
import ArticleNavigationBox from '../ArticleNavigationBox/ArticleNavigationBox';
import { POST } from '../../constants';

/**
 * The dashboard view article component.
 *
 * @constructor
 * @param   {Object} props   The props passed to this component.
 * @return  {HTML}           The component HTML.
 */

class ArticleSingleView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentArticleId: props.articleId,
            currentArticleIndex: props.articleIndex,
            articleData: null
        };

        this.loadArticleData = this.loadArticleData.bind(this);
        this.moveToArticle = this.moveToArticle.bind(this);
    }

    componentDidMount() {
        this.moveToArticle(this.state.currentArticleId, this.state.currentArticleIndex);
        //this.loadArticleData(this.state.currentArticleId);
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentArticleId && nextProps.currentArticleIndex >= 0) {
            this.setState({
                currentArticleId: nextProps.currentArticleId,
                currentArticleIndex: nextProps.currentArticleIndex
            })
        }
    }

    loadArticleData(articleId) {
        this.setState({articleData: null});
        this.props.spinner.showSpinner();
        /*this.setState({ articleData: someShitArticle});
        this.props.spinner.hideSpinner();
        return;*/
        api.loadSingleArticle(articleId)
            .then((articleData) => {
                // This validation is used so that only the data from the last response is shown
                // (the user can fast navigate through the articles).
                if ((articleData.articleId + "") === (this.state.currentArticleId + "")) { // convert ids to string, some come as int
                    this.setState({articleData: articleData});
                }
                this.props.spinner.hideSpinner();

            })
            .catch((error) => {
                utils.logError(error, "ViewFeedArticle.componentWillMount():");
                xhr.handleAllErrors(error);
            });
    }

    moveToArticle(id, index) {
        this.setState({ currentArticleId: id, currentArticleIndex: index}, () => {
            this.loadArticleData(id);
        });
    };

    render() {

        return (
            <div className="dashboard-page__article-preview__content">
                <div className="dashboard-page__article-preview__header no-print">
                    <div className="previous-page-link-row">
                        <span onClick={this.props.closeArticleView} className='caret-and-text'>
                            <span className="la-TriangleLeft"></span>
                            <FormattedMessage id="Dashboard_Charts_UIText_dashboard.backToResults" />
                        </span>
                    </div>

                    <ArticleNavigationBox
                        fetchUrl={this.props.url}
                        fetchCountUrl={this.props.countUrl}
                        fetchUrlParams={this.props.urlParams}
                        articleId={this.state.currentArticleId}
                        articleIndex={this.state.currentArticleIndex}
                        verb={POST}
                        changeArticle={this.moveToArticle}
                    />
                </div>

                {this.state.articleData ?
                    <div>
                        <DeliveryIcons />
                        <PreviewArticle articleData={this.state.articleData} />
                    </div>
                    : <div className="spinner-static-fixed"></div>}
            </div>
        );
    }

}

export default withSpinner(ArticleSingleView);


//const someShitArticle = {"articleId":"38469393924","title":"Health care giant files class action lawsuit after insurance plan drops WellStar","source":"CBS46.com","section":null,"content":"Atlanta, GA (CBS46) WellStar Health Systems, Inc. <em>filed</em> a <em>federal</em> class-action <em>lawsuit</em> Tuesday, <em>claiming</em> <em>Anthem</em> Inc./Blue Cross <em>and</em> Blue Shield of Georgia, Inc. misled Obamacare patients into thinking","publishDate":1549538820000,"loadDate":1549545465414,"harvestDate":1549545446000,"wordCount":"268","author":null,"url":"https://ct.moreover.com/?a=38469393924&p=14e&v=1&x=Z61SQhrnUhRU7VY5etoVcQ&u1=RMM-Cert&u2=g7468","ctUrl":"https://ct.moreover.com/?a=38469393924&p=14e&v=1&x=Z61SQhrnUhRU7VY5etoVcQ","copyright":null,"language":"English","publicationType":"News","journalCode":null,"matchedEntities":[{"id":"5c08dd56f6c9b200019f513e","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5a947fca004735000153665d","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5bfc12514e7cfe00018152c7","companyTitle":"fast","companyNames":["with","and","by","or","in","out","was"],"contextKeywords":[],"exclusionKeywords":[],"uniqueThirdPartyId":"","categoryIds":["5a947fca004735000153665d","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"with\" OR \"and\" OR \"by\" OR \"or\" OR \"in\" OR \"out\" OR \"was\") OR content:(\"with\" OR \"and\" OR \"by\" OR \"or\" OR \"in\" OR \"out\" OR \"was\")))","dunsNumber":"00-000-0000","experianBusinessId":"000000000","entityUrl":"","hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5c08ded7beb6bd000164fa37","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5a947fca004735000153665d","5c08dd79f6c9b200019f51c1","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5c08dfd7beb6bd00016500b8","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5c08dd79f6c9b200019f51c0","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5c08ded7beb6bd000164fa77","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5a947fca004735000153665d","5c08dd79f6c9b200019f51c1","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5c08dd56f6c9b200019f517e","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5a947fca004735000153665d","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null},{"id":"5c08dfd9beb6bd00016500f8","companyTitle":"Anthem","companyNames":["Anthem"],"contextKeywords":["Cigna","provider"],"exclusionKeywords":[],"uniqueThirdPartyId":"Anthem","categoryIds":["5c08dbdebeb6bd000164f234","5c08dd79f6c9b200019f51c0","5c08dc14beb6bd000164f36c"],"active":true,"filter":"((title:(\"Anthem\") OR content:(\"Anthem\")) AND (title:(\"Cigna\" OR \"provider\") OR content:(\"Cigna\" OR \"provider\")))","dunsNumber":"11-111-2261","experianBusinessId":"111112261","entityUrl":null,"hasSanctionsAndWatchLists":true,"tempCategories":null,"errorCategories":null}],"scores":[[{"name":"legal","pguid":"2993D78F66A7420C880955E1AB977955","englishName":"CLASS ACTIONS","scoreLevel":"H","stringLength":51},{"name":"legal","pguid":"A110C814CEF24B88915D6C38EC97DA63","englishName":"SUITS & CLAIMS","scoreLevel":"L","stringLength":52},{"name":"legal","pguid":"D685A67EB84341AABD87EBC43A387383","englishName":"LITIGATION","scoreLevel":"M","stringLength":48}]],"licensed":false}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Articles/ArticleSingleView.jsx